<template>
  <div>
    <el-table id="codingLargeStatTopDrgs" :data="dashboardData.length ? dashboardData[0].largeStats[2].data : []" empty-text="No DRGs Available" :fit="true"
      :height="isModal ? null : '300'" show-summary :summary-method="getSummary">
      <el-table-column prop="drgOrApc" label="DRG" width="50" sortable>
      </el-table-column>
      <el-table-column prop="description" label="Description">
        <template slot-scope="scope">
          <span style="text-transform: lowercase;">{{scope.row.description}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalCoded" label="Total" width="60" sortable>
      </el-table-column>
    </el-table>
    <div style="font-size: 15px; position: absolute; bottom: 5px;">
      {{dashboardData.length ? dashboardData[0].largeStats[2].footer : ''}}
    </div>
  </div>
</template>

<script>
  import money from '@/mixins/money'

  export default {
    props: ['dashboardData'],
    mixins: [money],
    components: {
    },
    data: function () {
      return {
      }
    },
    name: 'TopDrgsTable',
    methods: {
      patientTypeGetDrillDownForRow(row) {
        return row.consultants.length ? row.consultants : []
      },
      moneyFormatter(row, column) {
        return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
      },
      totalSummary(column, data) {
        let response = data.reduce((total, curr) => {
          const value = Number(curr[column])
          if (!isNaN(value)) {
            return total + value
          } else {
            return total
          }
        }, 0)

        return response
      },
      getSummary(param) {
        const totalCoded = this.totalSummary('totalCoded', param.data)
        return [null, null, totalCoded]
      }
    },
    created: function () {
    },
    computed: {
      isModal() {
        return this.$parent.modal
      }
    }
  }
</script>
